import { DataSource, Layout, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierScorecardHistory extends Layout {
    searchpanelScorecardHistory: SearchPanel;
    sourceCarrierPerfCalculation: DataSource;
    sourceCarrierPerformanceMetric: DataSource;
    tableCarrierScorecard: Table;
    textboxCalculationDate: Textbox;
    textboxCarrier: Textbox;
    textboxRanking: Textbox;
}
